import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { DatePicker } from "@material-ui/pickers";

import { useAuth } from "../../context/GlobalContext";
import formatDate from "../../components/Control/formatDate";
import useConfirm from "../../components/Control/useConfirm";
import ApprovalSelect from "./ApprovalSelect";
import ApprovalSupervisor from "./ApprovalSupervisor";
import UpdateIcon from "@material-ui/icons/Update";
import { Wrapper } from "../../components/Control/Flexbox";

const useStyles = makeStyles({
  table: {
    width: "100%",
    marginTop: "1.5rem",
    backgroundColor: "white",
  },
});
const statusObj = {
  pending: 1,
  accepted: 2,
  rejected: 3,
};
const ProductionPlanning = () => {
  const classes = useStyles();
  const { state } = useAuth();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [render, setRender] = useState(false);
  const [productionPlanningData, setProductionPlanningData] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [filter, setFilter] = useState("");
  const [DialogDelete, confirmDelete] = useConfirm(
    "SAVE",
    "Are you sure you want to Delete this report?",
  );

  useEffect(() => {
    axios
      .get("/api/getAllDepartment")
      .then((res) => {
        if (res.data) {
          setDepartments(res.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    axios
      .get(
        `/api/getProductionPlanning/all/${selectedDate}/${state.user.userType}?department=${filter}`,
      )
      .then((res) => setProductionPlanningData(res.data));
  }, [selectedDate, render, filter]);

  const handleDelete = async (id) => {
    const isConfirm = await confirmDelete();

    if (isConfirm) {
      axios
        .delete(`/api/deleteProductionPlanning/${id}`)
        .then((res) => {
          alert("success deleted");
          setRender((prev) => !prev);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleChangeStatus = (e, index) => {
    const values = [...productionPlanningData];
    values[index].is_admin_request = null;
    values[index].is_admin_request_no = e.target.value;
    setProductionPlanningData(values);
  };

  const updateStatus = async (id, index) => {
    let isConfirm = window.confirm("Are you sure you want to update status");
    if (!isConfirm) return;

    axios
      .patch(`/api/updateProductionById/${id}`, {
        is_admin_request_no: productionPlanningData[index].is_admin_request_no,
        report_approved_by: state.user?.name,
      })
      .then((res) => {
        if (res.data.status === "success") {
          alert("Status Change successfully");
        }
        setRender((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <section>
      <div style={{}}>
        <div
          className="divflex"
          style={{
            fontSize: "24px",
            textTransform: "uppercase",
          }}
        >
          Production Planning & Control
          <div>
            <Link
              to={`/createProductionPlanning/table/`}
              style={{ color: "white", textDecoration: "none" }}
            >
              <Button
                variant="contained"
                color="primary"
                size="large"
                style={{
                  // marginBottom: "1rem",
                  backgroundColor: "#054a29",
                }}
                startIcon={<AddCircleIcon />}
              >
                New REPORT
              </Button>
            </Link>
          </div>
        </div>

        <div className="subheading-container">
          <p className="subheading-primary">
            ACTIVE <span className="subheading-secondary">REPORTS</span>
          </p>
        </div>
      </div>
      <Wrapper justify="space-between">
        <div style={{ display: "flex", margin: "1rem" }}>
          <DatePicker
            views={["month", "year"]}
            label="Month & Year"
            className="date-field"
            inputVariant="filled"
            value={selectedDate || null}
            onChange={setSelectedDate}
          />
        </div>
        <FormControl
          variant="filled"
          className="select-field"
          style={{
            marginRight: "1.5rem",
            marginTop: "0.8rem",
            flex: "0.2",
            textTransform: "uppercase",
          }}
        >
          <InputLabel style={{ textTransform: "capitalize" }}>
            Select Department
          </InputLabel>
          <Select
            name="department"
            onChange={(e) => {
              // setting page no. before setting filter value
              setFilter(e.target.value);
            }}
            value={filter}
          >
            <MenuItem value={""}>NONE</MenuItem>
            {departments.map((department, index) => (
              <MenuItem
                value={department._id}
                style={{ textTransform: "uppercase" }}
              >
                {department?.department_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Wrapper>
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow style={{ padding: "6px" }}>
            {[
              "#",
              "Shift",
              "Old Department",
              "Department",
              "Status",
              "Created At",
              "Action",
            ].map((item, index) => (
              <TableCell style={{ fontWeight: "bold" }} align="center">
                {item}
              </TableCell>
            ))}
            {state.user?.userType === 2 && (
              <TableCell style={{ fontWeight: "bold" }} align="center">
                Update
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        {productionPlanningData && (
          <TableBody>
            {productionPlanningData.map((item, index) => (
              <React.Fragment key={item._id}>
                <TableRow>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell
                    align="center"
                    style={{ textTransform: "uppercase" }}
                  >
                    {item.shift}
                  </TableCell>
                  <TableCell align="center">
                    {item.processes.length &&
                      item?.processes[0].department_id?.department_name}
                  </TableCell>
                  <TableCell align="center">
                    {item?.department_id?.department_name}
                  </TableCell>

                  {/* approval */}
                  {state.user?.userType === 2 && (
                    <TableCell align="center">
                      <ApprovalSelect
                        {...{
                          handleChangeStatus,
                          item,
                          index,
                          statusObj,
                        }}
                      />
                    </TableCell>
                  )}

                  {state.user?.userType === 3 && (
                    <TableCell align="center">
                      <ApprovalSupervisor
                        {...{
                          item,
                        }}
                      />
                    </TableCell>
                  )}

                  {/* ---x--- */}

                  {/*  */}

                  <TableCell align="center">
                    {formatDate(item.productionPlanning_date)}
                  </TableCell>

                  <TableCell align="center">
                    <Tooltip title="View Daily Production" arrow>
                      <Link to={`/viewProductionPlanning/${item._id}`}>
                        <IconButton
                          size="small"
                          style={{ marginRight: "0.5rem" }}
                        >
                          <VisibilityIcon
                            style={{
                              fontSize: "1.4rem",
                              color: "#003566",
                            }}
                          />
                        </IconButton>
                      </Link>
                    </Tooltip>

                    {state.user.userType !== 3 && (
                      <>
                        <Tooltip title="Edit Daily Production" arrow>
                          <Link
                            to={`/createProductionPlanning/table/${item._id}`}
                          >
                            <IconButton
                              size="small"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <EditIcon
                                style={{
                                  fontSize: "1.4rem",
                                  color: "#003566",
                                }}
                              />
                            </IconButton>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Delete Daily Production" arrow>
                          <IconButton
                            size="small"
                            onClick={() => handleDelete(item._id)}
                          >
                            <DeleteIcon
                              style={{
                                fontSize: "1.4rem",
                                color: "#c80202",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}

                    {/* for supervisor */}
                    {state.user.userType == 3 && !item.isSubmitted && (
                      <>
                        <Tooltip title="Edit Daily Production" arrow>
                          <Link
                            to={`/createProductionPlanning/table/${item._id}`}
                          >
                            <IconButton
                              size="small"
                              style={{ marginRight: "0.5rem" }}
                            >
                              <EditIcon
                                style={{
                                  fontSize: "1.4rem",
                                  color: "#003566",
                                }}
                              />
                            </IconButton>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Delete Daily Production" arrow>
                          <IconButton
                            size="small"
                            onClick={() => handleDelete(item._id)}
                          >
                            <DeleteIcon
                              style={{
                                fontSize: "1.4rem",
                                color: "#c80202",
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </TableCell>
                  {state.user?.userType === 2 && (
                    <TableCell align="center">
                      <Button
                        variant="outlined"
                        color="white"
                        style={{
                          color: "#fafafa",
                          backgroundColor: "#161A1D",
                        }}
                        onClick={(e) => {
                          updateStatus(item._id, index);
                        }}
                        startIcon={
                          <UpdateIcon style={{ fontSize: "1.4rem" }} />
                        }
                      >
                        Update
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        )}
      </Table>
      <DialogDelete isSubmitContent={true} />
    </section>
  );
};

export default ProductionPlanning;
